import type { ReactNode } from 'react';

export const symbol_bar_chart_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-160q-12.75 0-21.37-8.63Q160-177.25 160-190v-380q0-12.75 8.63-21.38Q177.25-600 190-600h80q12.75 0 21.38 8.62Q300-582.75 300-570v380q0 12.75-8.62 21.37Q282.75-160 270-160h-80Zm250 0q-12.75 0-21.37-8.63Q410-177.25 410-190v-360l140 140v220q0 12.75-8.62 21.37Q532.75-160 520-160h-80Zm110-336L410-636v-134q0-12.75 8.63-21.38Q427.25-800 440-800h80q12.75 0 21.38 8.62Q550-782.75 550-770v274Zm250 250L660-386v-54h110q12.75 0 21.38 8.62Q800-422.75 800-410v164Zm-8 163L82-792q-9-9.07-8.5-21.53Q74-826 83.05-835q9.06-9 21.5-9 12.45 0 21.45 9l709 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83Z"
		/>
	</svg>
);
